import React from 'react';
import PropTypes from 'prop-types';
import {Button, Nav, Card, Col, Row} from "react-bootstrap";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {useNavigate} from "react-router-dom";
import BaseDetailsPageHeader from "./BaseDetailsPageHeader";
import {faBookOpen} from "@fortawesome/free-solid-svg-icons";

const MultiModeDetailsPageHeader = ({title, iconText, iconType}) => {
    return (<BaseDetailsPageHeader title={title} iconBar={
        <>
            <p className={"h6 text-uppercase text-600"}>
                {iconText}
            </p>
            <Nav variant="tabs" className="flex-column">
                <Nav.Item>
                    <Nav.Link eventKey="current"><FontAwesomeIcon icon={iconType}/> Current</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                    <Nav.Link eventKey="historical"><FontAwesomeIcon icon={faBookOpen}/> Historical</Nav.Link>
                </Nav.Item>
            </Nav>
        </>
    }/>);
}

MultiModeDetailsPageHeader.propTypes = {
    title: PropTypes.node.isRequired,
    iconText: PropTypes.string.isRequired,
    iconType: PropTypes.string.isRequired
}
export default MultiModeDetailsPageHeader